import { IconButton, Menu, MenuItem, Typography } from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import DeleteIcon from "@mui/icons-material/Delete";
import FileDownloadRoundedIcon from "@mui/icons-material/FileDownloadRounded";

import { useState } from "react";

const FileItemMenu = ({ onDownload, onDelete, disableDelete = false }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleDownload = () => {
    onDownload();
    handleClose();
  };

  const handleDelete = () => {
    onDelete();
    handleClose();
  };

  return (
    <>
      <IconButton
        aria-label="more"
        aria-controls="file-menu"
        aria-haspopup="true"
        onClick={handleClick}
      >
        <MoreVertIcon />
      </IconButton>
      <Menu
        id="file-menu"
        anchorEl={anchorEl}
        keepMounted
        open={open}
        onClose={handleClose}
        props={{
          style: {
            width: "150px",
            boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.15)",
            borderRadius: "4px",
          },
        }}
      >
        <MenuItem onClick={handleDownload} sx={{ py: 1 }}>
          <FileDownloadRoundedIcon
            sx={{ mr: 1, fontSize: "18px", color: "primary.main" }}
          />
          <Typography variant="body2">Download</Typography>
        </MenuItem>
        {!disableDelete && (
          <MenuItem onClick={handleDelete} sx={{ py: 1 }}>
            <DeleteIcon sx={{ mr: 1, fontSize: "18px", color: "error.main" }} />
            <Typography variant="body2" color="error.main">
              Delete
            </Typography>
          </MenuItem>
        )}
      </Menu>
    </>
  );
};
export default FileItemMenu;
